module.exports = __webpack_public_path__ + "media/app/assets/classes/mage-aed59aad51cbfb537d525cb380a25565.jpg";